















import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfilePictureEdit from '@/components/Commons/ProfilePictureEdit.vue';
import { vxm } from './../../store.vuex';
@Component({
  components: {
    ProfilePictureEdit,
  },
})
export default class ProfilePicture extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop() isLastStep;
  @Prop() isFinished;
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }
   async goToNext() {
    await vxm.users.validateMandatorySteps();
    if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
      this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
    }else {
      this.$emit('go-to-next');
    }
  }
  updateNextText(text) {
    this.$emit('update-next-text', text);
  }
}
